<template>
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5">
        <path d="M8 1.75L1.25 13.25h13.5L8 1.75z" stroke-linejoin="round" />
        <path d="M8 6.5v3M8 11.5v-.01" stroke-linecap="round" />
    </svg>
</template>

<script lang="ts" setup vapor>
defineOptions({ name: 'AlertIcon' });
</script>
